import React from 'react'
import './Signup.css'
import { Container,Row,Col,Image } from 'react-bootstrap'
import HeaderB from '../../components/headerb/HeaderB'
import LoginA from '../../components/loginb/LoginA'
import { Link } from 'react-router-dom';

export default function Welcome() {
  return (
<>

  <Container fluid > 
    <HeaderB /> 
  </Container>

  <Container center >
  <br /><br /><br />
    <Row >
        <Col xs={10} md={6} >
          <Image center className='welcome-image' src='./images/tozihat2.jpg' alt='توضیحات' thumbnail style={{border:'none'}} />
        </Col>

        <Col xs={12}  md={1} > </Col>

        <Col xs={8}  md={5} >
          <br /><br /><br />
          <Col xs={12}  md={{ span: 6, offset: 3 }}> <LoginA/> </Col>
        </Col>
    </Row>

    <Row>
      <Col xs={12}  md={0} > </Col>
    </Row>
    <br /><br /><br />
  </Container> 
</> )
}


